export const environment = {
  isProd: true,
  // shopGateUrl: "https://shopgate-lltey6qxxq-uc.a.run.app", //develop
  shopGateUrl: "https://shopgate-odc4c2t3wa-uc.a.run.app", //production
}